import type { ComponentProps, ReactNode } from 'react';
import { Divider, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import classNames from 'classnames';

import { Overflow, type TOverflowButtonParam } from '../Overflow';
import { VersionDropdown } from '../VersionDropdown';

const useStyles = makeStyles({
  meta: {
    lineHeight: tokens.lineHeightBase200,
    '& .fui-Body1Strong': { lineHeight: tokens.lineHeightBase200 },
  },
});

type TProps = {
  actions: TOverflowButtonParam[];
  versionDropdownProps: ComponentProps<typeof VersionDropdown>;
  // Rows about the shown version.
  children: ReactNode;
  // Rows about the item.
  itemRows: ReactNode;
};

const NavOverviewLayout = ({ actions, versionDropdownProps, children, itemRows }: TProps) => {
  const hasActions = actions.length > 0;
  const classes = useStyles();
  return (
    <div className={classNames('flex-col pt-2', { 'space-y-6': hasActions })}>
      <Overflow params={actions} label="More" spacing alignment="center" />
      <div className={mergeClasses('space-y-5 px-5', classes.meta)}>
        <div className={classNames('flex !-mb-1.5 items-center', { 'mt-8': hasActions })}>
          <span className="block w-32 flex-shrink-0">Viewing:</span>
          <VersionDropdown {...versionDropdownProps} />
        </div>
        {children}
        <Divider className="py-3" />
        {itemRows}
      </div>
    </div>
  );
};

export default NavOverviewLayout;
